import "./_image-map-styles.scss";

import './view';
